module.exports = __webpack_public_path__ + "img/Greenleaf.743d290b.png";